/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Practice } from '../../models/practice';

export interface UserPracticesGetAllPracticesOfUser$Params {
}

export function userPracticesGetAllPracticesOfUser(http: HttpClient, rootUrl: string, params?: UserPracticesGetAllPracticesOfUser$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Practice>>> {
  const rb = new RequestBuilder(rootUrl, userPracticesGetAllPracticesOfUser.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Practice>>;
    })
  );
}

userPracticesGetAllPracticesOfUser.PATH = '/userpractices';
